import {
  compose,
  toLower,
  defaultTo,
  identity,
  useWith,
  cond,
  always,
  prop,
  converge,
} from "ramda";
import { matchPath } from "react-router-dom";

import {
  HOME_ROUTE_PATTERN,
  CATEGORY_PAGE_PATTERN,
  ARTICLE_ROUTE_PATTERN,
  AUTHOR_ROUTE_PATTERN,
  TAG_RESULTS_ROUTE_PATTERN,
  SEARCH_RESULTS_ROUTE_PATTERN,
  ABOUT_ROUTE_PATTERN,
  NOT_FOUND_ROUTE_PATTERN,
} from "../../router/constants";

import {
  PAGE_HOME,
  PAGE_CATEGORY,
  PAGE_ARTICLE,
  PAGE_AUTHOR,
  PAGE_TAG_RESULTS,
  PAGE_SEARCH_RESULTS,
  PAGE_ABOUT,
  PAGE_NOT_FOUND,
} from "../constants";

const pageNameByRoutePattern = {
  [HOME_ROUTE_PATTERN]: PAGE_HOME,
  [CATEGORY_PAGE_PATTERN]: PAGE_CATEGORY,
  [ARTICLE_ROUTE_PATTERN]: PAGE_ARTICLE,
  [ABOUT_ROUTE_PATTERN]: PAGE_ABOUT,
  [AUTHOR_ROUTE_PATTERN]: PAGE_AUTHOR,
  [TAG_RESULTS_ROUTE_PATTERN]: PAGE_TAG_RESULTS,
  [SEARCH_RESULTS_ROUTE_PATTERN]: PAGE_SEARCH_RESULTS,
  [NOT_FOUND_ROUTE_PATTERN]: PAGE_NOT_FOUND,
};

const getNormalizedPathname = compose(toLower, defaultTo(""), identity);

const getPageNameFromRoutePattern = converge(prop, [
  identity,
  always(pageNameByRoutePattern),
]);

const isPathMatched = useWith(compose(Boolean, matchPath), [
  identity,
  getNormalizedPathname,
]);

const mapPathToRoutePattern = cond([
  [isPathMatched(HOME_ROUTE_PATTERN), always(HOME_ROUTE_PATTERN)],
  [isPathMatched(ABOUT_ROUTE_PATTERN), always(ABOUT_ROUTE_PATTERN)],
  [isPathMatched(SEARCH_RESULTS_ROUTE_PATTERN), always(SEARCH_RESULTS_ROUTE_PATTERN)],
  [isPathMatched(CATEGORY_PAGE_PATTERN), always(CATEGORY_PAGE_PATTERN)],
  [isPathMatched(ARTICLE_ROUTE_PATTERN), always(ARTICLE_ROUTE_PATTERN)],
  [isPathMatched(AUTHOR_ROUTE_PATTERN), always(AUTHOR_ROUTE_PATTERN)],
  [isPathMatched(TAG_RESULTS_ROUTE_PATTERN), always(TAG_RESULTS_ROUTE_PATTERN)],
  [isPathMatched(NOT_FOUND_ROUTE_PATTERN), always(NOT_FOUND_ROUTE_PATTERN)],
  [always(true), getNormalizedPathname],
]);

const getPageName = compose(getPageNameFromRoutePattern, mapPathToRoutePattern);

export default getPageName;
